
<script setup lang="ts">
import { ref } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useRouter,useRoute } from 'vue-router';

const router = useRouter();
const route = useRoute();

const goTo = (category) => {
    router.push({ path: `/tenant/translations/${route.params.translation}/${category}` });
};
</script>

<template>
    <div>
        <div class="row mt-5">
            <Card class="col-3 mr-3 mb-3">
                <template #title>
                    Questions & Answers
                </template>
                <template #subtitle>
                    Editing questions and answers
                </template>
                <template #footer>
                    <div class="d-flex justify-content-end">
                        <Button class="d-flex p-button-tuev" label="Edit" @click="goTo('faq/qa')" iconPos="right">
                            <template #icon>
                                <font-awesome-icon :icon="['fas', 'edit']" />
                            </template>
                        </Button>
                    </div>
                </template>
            </Card>
            <Card class="col-3 mr-3 mb-3">
                <template #title>
                    Categories
                </template>
                <template #subtitle>
                    Editing categories of the FAQ
                </template>
                <template #footer>
                    <div class="d-flex justify-content-end">
                        <Button class="d-flex p-button-tuev" label="Edit" @click="goTo('faq/categories/all')" iconPos="right">
                            <template #icon>
                                <font-awesome-icon :icon="['fas', 'edit']" />
                            </template>
                        </Button>
                    </div>
                </template>
            </Card>
        </div>
    </div>
</template>


<style scoped>
/* Add your styles here */
</style>